import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../resources/css/common.css";
import "../../resources/css/layout.css";
import ScrollAnimation from "../../resources/js/ScrollAnimation.js";
import Header from "../Header/Header.jsx";
import Footer from "./Footer.jsx";
//import promotion from "../../resources/img/promotions-241104.jpg";
import $ from "jquery";
import "../../resources/js/jquery.rwdImageMaps.js";

const Benefit = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 | 지원혜택`;

    // 페이지 뷰 추적
    window.gtag("config", "G-LYT78YCDYK", {
      page_path: location.pathname,
    });

    // IP 체크 함수
    const checkIP = async () => {
      const response = await fetch("/check-ip");
      const result = await response.json();

      // 리다이렉션 확인
      if (result.redirect) {
        navigate(result.redirect); // navigate로 리다이렉션
      }
    };

    checkIP(); // IP 체크 함수 호출
	
	// DOM 렌더링 후 rwdImageMaps 초기화
	$("img[usemap]").rwdImageMaps();
  }, [location, navigate]); // navigate 추가

  return (
    <div>
      <Header>
        <div className="header-down">
          <div className="wrap">
            <ul>
              <li>
                <a href="/startUp">아소비 창업</a>
              </li>
              <li>
                <a href="/startInfo">창업 안내</a>
              </li>
              <li>
                <a href="/startProcess">창업 절차</a>
              </li>
              <li>
                <a href="/benefit" className="sel">
                  지원 혜택
                </a>
              </li>
              <li>
                <a href="/asobimanager">아소비 지사장</a>
              </li>
            </ul>
          </div>
        </div>
      </Header>
      <ScrollAnimation />
      <section id="container">
        <div className="subvisual">
          <div className="title"> 아소비 창업</div>
          <div className="text">
            꾸준히 늘어나는 가맹으로 증명하는 아소비 창업! <br />
            아소비에 대해 알아보고 당신도 성공하는 창업자가 되어 보세요.{" "}
          </div>
          <div className="image">
            <img src="../custom-resources/img/sub_startup_bg.png" alt="" />
          </div>
        </div>
        <div className="breadcrumb">
          <div className="wrap">
            <div className="loca">
              <span>
                <img src="../custom-resources/img/icon_home.png" alt="" />
              </span>
              <span className="on">아소비 창업</span>
            </div>
            <div className="menu">
              <a href="/startInfo">창업 안내</a>
              <a href="/startProcess">창업 절차</a>
              <a href="/benefit" className="on">
                지원 혜택
              </a>
              <a href="/asobimanager">아소비 지사장</a>
            </div>
          </div>
        </div>
        <div className="benefit">
    {/*	<div class="sect benefit00">
		  <div class="img">
		    <img
		      src={promotion}
		      usemap="#main_map"
		      class="top_main_img"
		      alt=""
		    />
		    <map name="main_map">
		      <area
		        target="_blank"
		        alt="Asobi"
		        title="자세히 보기"
		        href="https://asobi24.gabia.io/"
		        coords="789,863,1144,960"
		        shape="rect"
		      />
		    </map>
		  </div>
		</div>*/}
          <div className="sect benefit01">
            <div className="wrap">
              <div className="tit init">
                우리 동네 최고의 아소비가 되기까지 본사가 함께합니다.
              </div>
              <div className="txt init">
                본사가 마련한 다양한 교육 프로그램, 지역 지사장님과 원장님들이
                함께 진행하는 홍보 활동 등을 통해 <br />
                지역 내 최고의 아소비로 자리 잡을 수 있게 지원해 드립니다.
              </div>
              <div className="img init">
                <img src="../custom-resources/img/img_benefit_benefit01.png" alt="" />
              </div>
            </div>
          </div>
          <div className="sect benefit02">
            <div className="wrap">
              <div className="list">
                <ul>
                  <li className="init">
                    <div className="con">
                      <div className="thm">
                        <img
                          src="../custom-resources/img/img_benefit_benefit02_img01.png"
                          alt=""
                        />
                        <img
                          src="../custom-resources/img/img_benefit_benefit02_img01_sub.png"
                          className="mo-view"
                          alt=""
                        />
                      </div>
                      <span>지원 혜택 1</span>
                      <strong>오픈 지원</strong>
                      <p>
                        복잡하고 까다로운 교육청 신고, 지사장의 도움을 받아 쉽게
                        처리할 수 있습니다. <br />
                        또한, 아소비는 공부에 집중할 수 있는 기본 여건만
                        충족된다면 별도의 인테리어 제한을{" "}
                        <br className="pc-view" />
                        두지 않아 기존 물품을 계속 사용하는 등 인테리어에 대한
                        부담이 없습니다.
                      </p>
                    </div>
                    <div className="img">
                      <img
                        src="../custom-resources/img/img_benefit_benefit02_img01_sub.png"
                        alt=""
                      />
                    </div>
                  </li>
                  <li className="init">
                    <div className="con">
                      <div className="thm">
                        <img
                          src="../custom-resources/img/img_benefit_benefit02_img02.png"
                          alt=""
                        />
                        <img
                          src="../custom-resources/img/img_benefit_benefit02_img02_sub.png"
                          className="mo-view"
                          alt=""
                        />
                      </div>
                      <span>지원 혜택 2</span>
                      <strong>교육 지원</strong>
                      <p>
                        본사 가맹 교육, OJT 교육, 지사 교육, 정기 교육 등으로
                        이루어진 교육 프로그램을 통해 오픈 후 교육원을 운영하는
                        데 있어 전혀 어려움이 없도록 도와드립니다. 이러한 교육
                        프로그램을 통해 유아 지도 경험이 없는 분도 어려움 없이
                        아소비 원장님이 될 수 있습니다.{" "}
                        <br className="pc-view" />
                        또한 가맹 후에도 아소비의 교육 이념을 현장에서 적용하는
                        데 어려움이 없도록 다양하고 <br className="pc-view" />
                        지속적인 교육을 시행하고 있습니다.
                      </p>
                    </div>
                    <div className="img">
                      <img
                        src="../custom-resources/img/img_benefit_benefit02_img02_sub.png"
                        alt=""
                      />
                    </div>
                  </li>
                  <li className="init">
                    <div className="con">
                      <div className="thm">
                        <img
                          src="../custom-resources/img/img_benefit_benefit02_img03.png"
                          alt=""
                        />
                        <img
                          src="../custom-resources/img/img_benefit_benefit02_img03_sub.png"
                          className="mo-view"
                          alt=""
                        />
                      </div>
                      <span>지원 혜택 3</span>
                      <strong>운영 지원</strong>
                      <p>
                        아소비는 교육원 운영의 만족감과 행복감을 드리기 위해{" "}
                        <br />
                        다양한 물품 및 이벤트를 지원합니다.
                      </p>
                      <div className="item">
                        <em>우수교육원, 장기교육원 순금카드 및 상품권 지원</em>
                        <em>워라밸(취미) 활동 비용 지원</em>
                        <em>영상 홍보 콘텐츠 제작 지원</em>
                        <em>본사 주최 문화 행사 초대</em>
                        <em>회원학부모 대상 이벤트</em>
                        <em>놀이동산, 워터파크 등 특가 티켓 지원</em>
                      </div>
                    </div>
                    <div className="img">
                      <img
                        src="../custom-resources/img/img_benefit_benefit02_img03_sub.png"
                        alt=""
                      />
                    </div>
                  </li>
                  <li className="init">
                    <div className="con">
                      <div className="thm">
                        <img
                          src="../custom-resources/img/img_benefit_benefit02_img04.png"
                          alt=""
                        />
                        <img
                          src="../custom-resources/img/img_benefit_benefit02_img04_sub.png"
                          className="mo-view"
                          alt=""
                        />
                      </div>
                      <span>지원 혜택 4</span>
                      <strong>홍보 지원</strong>
                      <p>
                        TV 광고, 라디오 광고, 각종 SNS 광고, 네이버 키워드 광고,
                        지역 맘카페 입점, 학부모 설명회 개최, 파라솔 홍보, 연합
                        홍보, 소식지 발행과 더불어 각종 홍보 물품을 저렴하게
                        제공하는 아소비 내부 쇼핑몰 등을 통해 교육원이 우리동네
                        최고로 자리 잡기까지 아낌없는 홍보 지원을 해드립니다.
                      </p>
                    </div>
                    <div className="img">
                      <img
                        src="../custom-resources/img/img_benefit_benefit02_img04_sub.png"
                        alt=""
                      />
                    </div>
                  </li>
                  <li className="init">
                    <div className="con">
                      <div className="thm">
                        <img
                          src="../custom-resources/img/img_benefit_benefit02_img05.png"
                          alt=""
                        />
                        <img
                          src="../custom-resources/img/img_benefit_benefit02_img05_sub.png"
                          className="mo-view"
                          alt=""
                        />
                      </div>
                      <span>지원 혜택 5</span>
                      <strong>초도 물품 지원</strong>
                      <p>
                        아소비 교육원 가맹 비용에는 초도 물품비가 포함되어
                        있습니다. <br />
                        샘플 교재, 각종 홍보 물품, 아소비 전용 공방에서
                        수작업으로 제작되는 원목 교구장, 교구 세트 등 원장님이
                        빠르고 간편하게 교육원을 꾸릴 수 있도록 지원해 드립니다.
                      </p>
                    </div>
                    <div className="img">
                      <img
                        src="../custom-resources/img/img_benefit_benefit02_img05_sub.png"
                        alt=""
                      />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Benefit;
